/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray } from './util.js';
import { MDTrees } from './tree-data.js';
import { BasicSearchRequest } from './basic-search-request.js';


class SearchRequest extends BasicSearchRequest {

	constructor( state ) {
		super(state);
	}

	newInstance() {
		// console.log('SearchRequest::newInstance()');
		return new SearchRequest(this._state);
	}

	getFlatCategoriesList() {
		var fc = this._state.in_categories,
			fcl = fc.length,
			fnit = this._state.not_in_trees,
			fnitl = fnit.length,
			c = [],
			i;
		for( i=0; i<fcl; ++i ) c.push( [ fc[i]==-1 ? 1 : MDTrees.getTreeIdFromCategoryId(fc[i]), fc[i] ] );
		for( i=0; i<fnitl; ++i ) c.push( [ fnit[i], 0 ] );
		return c;
	}

	addFlatCategoriesList( categories ) {
		const cl = categories.length;
		for( let i=0; i<cl; ++i ) {
			const cat_id = categories[i][1];
			const tree_id = cat_id==-1 ? 1 : ( categories[i][0] || MDTrees.getTreeIdFromCategoryId(cat_id) );
			if( tree_id!==null ) {
				if( cat_id==0 ) {
					this._state.not_in_trees.push(tree_id);
				} else {
					if( arr_inArray(tree_id,this._state.in_trees)===-1 ) this._state.in_trees.push(tree_id);
					this._state.in_categories.push(cat_id);
				}
			}
		}
	}

	inflateCategories() {
		this._state.in_trees = [];
		const cl = this._state.in_categories.length;
		for( var i=0; i<cl; ++i ) {
			const cat_id = this._state.in_categories[i];
			const tree_id = cat_id==-1 ? 1 : MDTrees.getTreeIdFromCategoryId(cat_id);
			if( tree_id!==null && arr_inArray(tree_id,this._state.in_trees)===-1 ) this._state.in_trees.push(tree_id);
		}
		// TODO: inflate metasearch_values too ??
	}

	withCategoriesInflated() {
		let new_sr = this.newInstance();
		new_sr.setTransientTitle(this.getTransientTitle());
		new_sr.setObjectId(this.getObjectId());
		new_sr.setAdditionalData(this.getAdditionalData());

		// compute values of "in_trees" ...
		new_sr.inflateCategories();
		/*var flat_categories = new_sr.getFlatCategoriesList();
		new_sr.removeCategoriesFilter();
		new_sr.addFlatCategoriesList(flat_categories);*/

		return new_sr;
	}

	withCategoriesDeflated() {
		const tcl = this._state.in_categories.length;
		let scat_hashes = {};
		let done_hashes = {};
		let result_categories = [];
		for( let i=0; i<tcl; ++i ) scat_hashes[this._state.in_categories[i]] = 1;

		function _set_done_recurse( tree_id, cat_id ) {
			done_hashes[cat_id] = 1;
			MDTrees.foreachChildCategoryNodeOrdered(tree_id,cat_id,function( ccat_id, ccnode ) {
				if( scat_hashes.hasOwnProperty(ccat_id) ) _set_done_recurse(tree_id,ccat_id);
			});
		}

		function _set_done( tree_id, cat_id ) {
			done_hashes[cat_id] = 1;
			let all_descendants_selected = true;
			MDTrees.foreachDescendantCategoryNodeOrdered(tree_id,cat_id,function( ccat_id, ccnode ) {
				if( !scat_hashes.hasOwnProperty(ccat_id) ) {
					all_descendants_selected = false;
					return false;
				}
			});
			if( all_descendants_selected ) {
				MDTrees.foreachDescendantCategoryNodeOrdered(tree_id,cat_id,function( ccat_id, ccnode ) {
					done_hashes[ccat_id] = 1;
				});
			} else {
				MDTrees.foreachChildCategoryNodeOrdered(tree_id,cat_id,function( ccat_id, ccnode ) {
					_set_done_recurse(tree_id,ccat_id);
				});
			}
		}

		for( let i=0; i<tcl; ++i ) {
			const cat_id = this._state.in_categories[i];
			if( !done_hashes.hasOwnProperty(cat_id) ) {
				if( cat_id==-1 ) {
					// pass "unknown" category without child traversal
					result_categories.push(cat_id);
				} else {
					// traverse category descendants ..
					const tree_id = MDTrees.getTreeIdFromCategoryId(cat_id);
					if( tree_id!==null ) {
						_set_done(tree_id,cat_id);
						result_categories.push(cat_id);
					}
				}
			}
		}
		let new_sr = this.newInstance();
		new_sr.setCategoryXFilter( {
			in_trees: this._state.in_trees,
			categories: result_categories,
			not_in_trees: this._state.not_in_trees,
			metasearch_trees: this._state.metasearch_trees,
			metasearch_values: this._state.metasearch_values
		} );
		new_sr.setTransientTitle(this.getTransientTitle());
		new_sr.setObjectId(this.getObjectId());
		new_sr.setAdditionalData(this.getAdditionalData());
		return new_sr;
	}

	deflatedForURLRequest() {
		let new_sr = this.newInstance();
		new_sr.normalize();
		new_sr = new_sr.withCategoriesDeflated();
		new_sr.deflateForURLRequest();
		new_sr.setTransientTitle(this.getTransientTitle());
		new_sr.setObjectId(this.getObjectId());
		new_sr.setAdditionalData(this.getAdditionalData());
		return new_sr;
	}

}


function createSearchRequest( state ) {
	return new SearchRequest(state);
}

function unserializeSearchRequest( state_json ) {
	return createSearchRequest(JSON.parse(state_json));
}





export {
	SearchRequest,
	createSearchRequest,
	unserializeSearchRequest,
};

